module.exports = __webpack_public_path__ + "img/icon_custom.a0a4721.svg";